import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Pennsylvania`}</h1>
    <p>{`I used to wish I wasn’t from a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/State_College,_Pennsylvania"
      }}>{`small town`}</a>{` in the middle of Pennsylvania. I could be from, you know, `}<em parentName="p">{`New York`}</em>{`.`}</p>
    <p>{`(Spoiler: this weekend I’m moving to NYC to attend NYU!)`}</p>
    <p>{`But in recent years, even though my primary `}<a parentName="p" {...{
        "href": "https://hackclub.com/community/"
      }}>{`communities`}</a>{` are absolutely online, I’ve become really proud of where I’m from. Sure, it’s a small college town, & I live quite literally in the middle of a forest, but it’s awesome here. We have space here. In the summer, the sound outside is the cicadas in the trees. When it snows, it’s dead quiet.`}</p>
    <p><img parentName="p" {...{
        "src": "https://cdn.glitch.com/a9442788-bc48-44ab-bedd-832d738c93dd%2FIMG_0755.jpeg",
        "alt": "Snowy forest"
      }}></img></p>
    <p>{`I went to a public high school where plenty of kids are farmers.`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` We have school off for deer hunting (actually).`}</p>
    <p>{`As I’ve engaged more with my local community, I’ve become even more proud of it. My friends & I led a campaign to open gender-neutral bathrooms for all students at our high school. I’m part of a local LGBTQ+ youth group. Last winter I organized `}<a parentName="p" {...{
        "href": "https://hackpenn.com"
      }}>{`Hack Pennsylvania`}</a>{`, a 111-person high school hackathon during a blizzard. Students drove from all over the state (even Maryland!) to come. What we made happen was totally unique.`}</p>
    <p>{`Looking ahead at my life, the cities will always be there, bustling, & growing. I’m incredibly excited (if a little nervous) to go to NYC—it’s the place I most want to be at this stage of my life. But being able to come home under the trees, I wouldn’t trade that for anything else. It’s an incredible privilege.`}</p>
    <p>{`It felt good to update my `}<a parentName="p" {...{
        "href": "https://lachlanjc.me"
      }}>{`personal site`}</a>{` the other day. `}<inlineCode parentName="p">{`Proudly from Pennsylvania. Now based in NYC.`}</inlineCode></p>

    <div {...{
      "className": "footnotes"
    }}>
      <hr parentName="div"></hr>
      <ol parentName="div">
        <li parentName="ol" {...{
          "id": "fn-1"
        }}>{`Farmers are going to save us from starving as the apocalypse becomes reality. Support independent farmers!`}<a parentName="li" {...{
            "href": "#fnref-1",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
      </ol>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      